<template>
    <component :is="component" :items="items" :filter="filter" :itemsPerPage="itemsPerPage" ref="opTableRef"
        :op-name="opName" @filteadrsCleared="setFilters" :showUpperPagination="showUpperPagination" :showLowerPagination="showLowerPagination"
        :totalItemsCount="totalItemsCount" @search="search" :clear-filters="clearFilters" :filtersFn="filtersFn">
        
        <template v-slot:default="slotProps">
            <slot :items="slotProps.items"  />
        </template>
    </component>
</template>

<script lang="ts">
import opTableLocal from '@/components/opTable/opTableLocal.vue';
import opTableServerSide from '@/components/opTable/opTableServerSide.vue';
import { StorageServices } from '@/services/StorageServices';
import store from '@/store';
import { markRaw } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    components: {
        opTableLocal,
        opTableServerSide
    }
})
export default class OpTable extends Vue {
    @Prop({
        default: []
    }) items: any[];
    @Prop({
        default: true
    }) showUpperPagination: boolean;
    @Prop({
        default: true
    }) showLowerPagination: boolean;
    @Prop({
        type: Number,
        default: 10
    }) itemsPerPage: number;
    @Prop({
        required: false
    }) filter: any;
    @Prop() name: string;
    @Prop({ default: () => { return {} } }) filtersFn: any;
    @Prop({
        required: false
    }) totalItemsCount: number;
    @Prop() clearFilters: number;

    search(filter){
        this.$emit("search", this.filter)
    }

    component: any = null;

    opName: string = "";

    created(){
        this.opName = this.name || this.$route.path;

        if(this.filter){
            this.component = markRaw(opTableServerSide);
            let filters = StorageServices.getOpTableFilters(this.opName);
            for(let p in filters){
                this.filter[p] = filters[p];
            }
        } else {
            this.component = markRaw(opTableLocal);
        }

        store.state.beforeNavCbs.push((to, from) => {
            this.setFilters();
        })
         
        window.addEventListener('beforeunload', this.setFilters);
    }

    beforeUnmount(){
        this.setFilters();
        window.removeEventListener('beforeunload', this.setFilters);
    }

    setFilters(){
        if(this.filter){
            StorageServices.setOpTableFilters(this.opName, this.filter);
        } else {
            let opTableComponent = this.$refs.opTableRef as any;
            if(!opTableComponent)
                return;
            let filters = opTableComponent.filterInputs;
            let toSave = {};
            filters.forEach(x => {
                toSave[x.name] = x.value;
            });
            StorageServices.setOpTableFilters(this.opName, toSave);
        }
    }



}
</script>
